import type { Event } from 'models';
import { useMemo } from 'react';

export const useEventInviteesCount = ({ goingCount, notGoingCount, pendingCount }: Event) =>
  // -1 because the author is not included in the invitee count used to enforce the limit.
  useMemo(() => goingCount + notGoingCount + pendingCount - 1, [goingCount, notGoingCount, pendingCount]);
